import { createContext, useContext } from "react";

const ManageGeneralFormContext = createContext();

export const ManageGeneralFormProvider = ({ children, formik, ...otherProps }) => {
  return (
    <ManageGeneralFormContext.Provider
      value={{
        formik,
        ...otherProps,
      }}
    >
      {children}
    </ManageGeneralFormContext.Provider>
  );
};

export const useManageGeneralFormContext = () => {
  const ctx = useContext(ManageGeneralFormContext);
  if (!ctx) {
    throw new Error("useManageGeneralFormContext must be used inside <ManageGeneralFormProvider>");
  }
  return ctx;
};
